import { faXmark } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Box, Button, Flex, SxProps, Text, Tooltip } from '@modusign/design-system';
import { useDispatch, useSelector } from 'react-redux';
import { useToggle } from 'react-use';

import useMemberPermissions from '@app/hooks/useMemberPermission';
import { getNetPermission } from '@app/libs/permission/getNetPermission';
import { getHasExternalDocumentPermission } from '@app/store/user/authority/selectors';

import { confirmManagementTooltip, getShowManagementTooltip } from '../../state';
import DocumentManagementModal from './DocumentManagementModal';

interface DocumentManagementButtonProps extends SxProps {}

export default function DocumentManagementButton({ sx }: DocumentManagementButtonProps) {
  const dispatch = useDispatch();

  const hasExternalDocumentPermission = useSelector(getHasExternalDocumentPermission);
  const { permissionMap } = useMemberPermissions();
  const { isPermitted, message } = getNetPermission({
    hasAuthorityPermission: hasExternalDocumentPermission,
    hasRolePermission: permissionMap.UPDATE_EXTERNAL_DOCUMENT,
  });
  const showTooltip = useSelector(getShowManagementTooltip);
  const [isOpen, toggle] = useToggle(false);

  const tooltipContent = !isPermitted ? (
    message
  ) : (
    <Flex alignItems="center">
      <Text fontSize="xs">계약 관리 기능을 통해 계약 정보를 일괄로 업데이트할 수 있습니다.</Text>
      <Box
        as="button"
        height="20px"
        ml={1}
        type="button"
        width="20px"
        onClick={() => dispatch(confirmManagementTooltip())}
      >
        <FontAwesomeIcon icon={faXmark} />
      </Box>
    </Flex>
  );

  return (
    <>
      <Tooltip
        content={tooltipContent}
        isOpen={isPermitted ? showTooltip : undefined}
        placement={isPermitted ? 'right' : 'bottom'}
      >
        <Button disabled={!isPermitted} sx={sx} weight="light" whiteSpace="nowrap" onClick={toggle}>
          계약 관리
        </Button>
      </Tooltip>
      {isOpen && <DocumentManagementModal isOpen onClose={toggle} />}
    </>
  );
}
